import React, { useCallback } from 'react';

import { AnimatePresence } from 'framer-motion';

import { EmailPreferencesModal } from '@pkg/components/EmailPreferencesModal';
import { TwitterConnectModal } from '@pkg/components/TwitterConnect/TwitterConnectModal';
import { CreateWishlistModal } from '@pkg/components/Wishlist/CreateWishlistModal';
import { WishlistToast } from '@pkg/components/Wishlist/WishlistToast';
import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { setEmailPreferencesIsOpen } from '@app/store/actions/dashboard';
import { globalNavigationActions } from '@app/store/slices';

export function Modals() {
    const showCreateWishlistModal = useAppSelector((state) => state.globalNavigation.showCreateWishlistModal);
    const emailPreferencesIsOpen = useAppSelector((state) => state.dashboard.emailPreferencesIsOpen);

    const dispatch = useAppDispatch();

    const handleCreateWishlistToggle = () => {
        dispatch(globalNavigationActions.showCreateWishlistModal(!showCreateWishlistModal));
    };

    const handleCloseEmailPreferences = useCallback(() => {
        dispatch(setEmailPreferencesIsOpen(false));
    }, [dispatch]);

    return (
        <>
            <TwitterConnectModal />

            <AnimatePresence>
                {emailPreferencesIsOpen ? <EmailPreferencesModal onClose={handleCloseEmailPreferences} /> : null}

                {showCreateWishlistModal ? <CreateWishlistModal onClose={handleCreateWishlistToggle} /> : null}
            </AnimatePresence>

            <WishlistToast />
        </>
    );
}
